import { ConnectComponent2 } from "util";
import View from "./view";
import Presenter from "./presenter";

const states = [
  {
    name: "app.registration.customer.manage",
    url: "/configurar-campos",
    views: {
      "content@app": ConnectComponent2(View, Presenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/manage-fields/index.js